import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Banner, BannerTypesEnum} from '../../../../../libs/shared/ui/src/components/banners/banner';
import {BannerAction} from '../../../../../libs/shared/ui/src/components/banners/bannerAction';
import {BannerCloseAction} from '../../../../../libs/shared/ui/src/components/banners/bannerCloseAction';
import {BannerContent} from '../../../../../libs/shared/ui/src/components/banners/bannerContent';
import {BannerContentTitle} from '../../../../../libs/shared/ui/src/components/banners/bannerContentTitle';
import {BannerFooterActions} from '../../../../../libs/shared/ui/src/components/banners/bannerFooterActions';
import {BannerIcon} from '../../../../../libs/shared/ui/src/components/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../../../libs/shared/ui/src/components/banners/bannersContext';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

export enum NewVersionBannersEnum {
  NEW_FRONTEND_VERSION = 'NEW_FRONTEND_VERSION',
  NEW_ELECTRON_VERSION = 'NEW_ELECTRON_VERSION',
}

interface NewVersionBannerProps {
  onDismissClick: () => void;
  onReloadClick: () => void;
  bannerType: NewVersionBannersEnum;
}

/*
 * Component.
 */

export const NewVersionBanner: FC<NewVersionBannerProps> = (props) => {
  const theme = useUserTheme();

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.palette.blue.shade40}
      priority={BannerPrioritiesEnum.INFORMATION}
    >
      <BannerCloseAction onClick={props.onDismissClick} />
      <BannerIcon iconName="giftSmall" />
      <BannerContent>
        <BannerContentTitle>
          <Trans id="banner-newversion-title">New version available</Trans>
        </BannerContentTitle>
        {renderBannerContent(props.bannerType)}
      </BannerContent>
      <BannerFooterActions>
        <BannerAction onClick={props.onReloadClick}>{renderBannerAction(props.bannerType)}</BannerAction>
      </BannerFooterActions>
    </Banner>
  );
};

function renderBannerContent(type: NewVersionBannersEnum) {
  switch (type) {
    case NewVersionBannersEnum.NEW_FRONTEND_VERSION:
      return (
        <Trans id="banner-newfrontendversion-content">
          Reload now to get the latest features and bug fixes.
        </Trans>
      );
    case NewVersionBannersEnum.NEW_ELECTRON_VERSION:
    default:
      return (
        <Trans id="banner-newelectronversion-content">
          Restart now to get the latest features and bug fixes.
        </Trans>
      );
  }
}

function renderBannerAction(type: NewVersionBannersEnum) {
  switch (type) {
    case NewVersionBannersEnum.NEW_FRONTEND_VERSION:
      return <Trans id="banner-newfrontendversion-reload">Reload the app</Trans>;
    case NewVersionBannersEnum.NEW_ELECTRON_VERSION:
    default:
      return <Trans id="banner-newelectronversion-restart">Restart the app</Trans>;
  }
}
